// @flow
import JQueryView, { on } from '../../common/JQueryView';
import {
  RESOLUTION_OTHER_CATEGORY,
  RESOLUTION_CLASS_STOCK_CATEGORY,
} from '../../../models/ResolutionCategory';

declare var $: any;

export default class ResolutionView extends JQueryView {
  constructor() {
    super('.company.director_meetings.resolution');
    this.render();
  }

  @on({ event: 'change', selector: '.resolution_select' })
  onChangeResolutionSelect(event: any) {
    this.showResolutionForm($(event.target));
  }

  showResolutionForm(select: any) {
    const select_val = Number(select.val());
    const stockTypeForm = select.parent().next();
    const otherForm = stockTypeForm.next();

    if (RESOLUTION_CLASS_STOCK_CATEGORY.includes(select_val)) {
      stockTypeForm.show();
      otherForm.hide();
    } else if (RESOLUTION_OTHER_CATEGORY.includes(select_val)) {
      otherForm.show();
      stockTypeForm.hide();
    } else {
      otherForm.hide();
      stockTypeForm.hide();
    }
  }

  render() {
    $('.resolution_select').each((i, a) => {
      this.showResolutionForm($(a));
    });
  }
}
